import type { ToolSlug } from './pages/ToolsPage';

export type ToolEvent = 'view' | 'result' | 'contact';

export const trackToolEvent = (tool: ToolSlug, event: ToolEvent) => {
  if (typeof window === 'undefined') return;
  void fetch('/api/tool-events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tool, event }),
    keepalive: true,
  }).catch(() => {
    // La mesure ne doit jamais interrompre l’outil.
  });
};
